import { validateCouponCode } from 'actions/Coupon';
import { handleNetworkError } from 'actions/Error';
import { getFreightForOrder } from 'actions/Freight';
import axios from 'axios';
import { showNotification } from 'notification';
import apiConfig from 'utilities/apiConfig';
import i18n from 'utilities/i18n';
export function addToCart(product, productContext) {
    return (dispatch) => {
        dispatch({ type: 'ADD_TO_CART', payload: Object.assign(Object.assign({}, product), { productContext }) });
        dispatch(checkCart());
        dispatch(getFreightForOrder());
        dispatch(applyCoupon());
    };
}
export function viewCart() {
    return (dispatch, getState) => {
        dispatch({ type: 'VIEW_CART', payload: getState().cart });
    };
}
function applyCoupon() {
    return (dispatch, getState) => {
        const couponCode = getState().coupon.code;
        if (couponCode) {
            dispatch(validateCouponCode());
        }
    };
}
export function addOrderToCart(order) {
    return (dispatch, getState) => {
        const products = getState().products.products;
        order.products.forEach(({ id, quantity }) => {
            const product = products.find((p) => +p.id === +id);
            while (product && quantity > 0) {
                dispatch({ type: 'ADD_TO_CART', payload: product });
                quantity--;
            }
        });
        dispatch(checkCart());
        dispatch(getFreightForOrder());
        dispatch(applyCoupon());
    };
}
export function removeFromCart(product) {
    return function (dispatch, getState) {
        dispatch({ type: 'REMOVE_FROM_CART', payload: product });
        dispatch(checkCart());
        dispatch(getFreightForOrder());
        const couponCode = getState().coupon.code;
        if (couponCode) {
            dispatch(validateCouponCode());
        }
    };
}
export function resetCartNotification() {
    return { type: 'RESET_CART_NOTIFICATION' };
}
export function setProductQuantity(quantity, product) {
    return (dispatch, getState) => {
        dispatch({ type: 'UPDATE_CART_QUANTITY', payload: { quantity, product } });
        dispatch(checkCart());
        dispatch(getFreightForOrder());
        const couponCode = getState().coupon.code;
        if (couponCode) {
            dispatch(validateCouponCode());
        }
    };
}
export function checkCart() {
    return (dispatch, getState) => {
        const deliveryDate = getState().checkout.deliveryDate;
        const products = getState().cart.products;
        const region = getState().region.slug;
        const isMobile = getState().ui.isMobile;
        dispatch({ type: 'FETCH_CHECK_CART', payload: [] });
        axios
            .post(`${process.env.API_URL}/api/check-cart`, {
            deliveryDate: deliveryDate,
            products: products,
            region: `${region}_no`,
        }, apiConfig)
            .then((response) => {
            const hasDisabledProductsForRegion = response.data.products.some((p) => p.disabledForRegion);
            const hasEnoughQuantity = !response.data.products.some((p) => p.quantity > p.quantityPossible);
            dispatch({
                type: 'FETCH_CHECK_CART_FULLFILLED',
                payload: Object.assign(Object.assign({}, response.data), { hasDisabledProductsForRegion, hasEnoughQuantity }),
            });
            if (hasDisabledProductsForRegion || !hasEnoughQuantity) {
                dispatch(showNotification({
                    style: 'ERROR',
                    text: i18n.t('notificationCartContainsUnavailableProducts'),
                }));
                if (!isMobile) {
                    dispatch({
                        type: 'TOGGLE_CART',
                        payload: true,
                    });
                }
            }
        })
            .catch((err) => {
            console.warn(err);
            dispatch({ type: 'FETCH_CHECK_CART_REJECTED', payload: err });
            dispatch(handleNetworkError(err, true));
        });
    };
}
